import { render, staticRenderFns } from "./SymbolDialog.vue?vue&type=template&id=020499b6"
import script from "./SymbolDialog.vue?vue&type=script&lang=js"
export * from "./SymbolDialog.vue?vue&type=script&lang=js"
import style0 from "./SymbolDialog.vue?vue&type=style&index=0&id=020499b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports